<template>
  <div v-if="show" class="bh-modal">
    <div class="bh-overlay" @click="$emit('close')" />

    <div class="bh-dialog" role="dialog" aria-modal="true">
      <div class="bh-header">
        <div class="bh-header-left">
          <div class="bh-app-icon" aria-hidden="true">
            <img alt="" src="../assets/icons/visionplus_icon.svg" />
          </div>
          <div class="bh-title">Cara Mendapatkan Benefit Anggota</div>
        </div>

        <button type="button" aria-label="Close" @click="$emit('close')">
          <img alt="" src="../assets/icons/close2.svg"/>
        </button>
      </div>

      <div class="bh-divider"></div>

      <div class="bh-body">
        <div class="bh-section">
          <div class="bh-section-title">Cara menjadi anggota resmi Perindo</div>
          <ol class="bh-steps">
            <li> Klik lengkapi form anggota pada KTA.</li>
            <li> Upload KTP kamu dan masukkan data-data yang diperlukan.</li>
            <li> Jika sudah terisi semua, klik Lanjutkan.</li>
            <li> Selamat, kamu resmi menjadi anggota Perindo.</li>
            <li> Tunggu beberapa waktu, kamu akan menerima SMS aktivasi otomatis Paket Merah Putih di Vision+.</li>
          </ol>
        </div>

        <div class="bh-section">
          <div class="bh-section-title">Cara mendapatkan akses Vision+</div>
          <ol class="bh-steps">
            <li> Login ke Vision+ menggunakan nomor handphone yang kamu daftarkan di sini.</li>
            <li> Paketmu Vision+ Merah Putih akan otomatis aktif dan bisa kamu nikmati.</li>
            <li> Paket berlaku selama 30 hari dan akan diperpanjang selama menjadi anggota aktif di Perindo.</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BenefitHowToModal',
  props: {
    show: { type: Boolean, default: false }
  },
  watch: {
    show (val) {
      if (val) document.addEventListener('keydown', this.onKeydown)
      else document.removeEventListener('keydown', this.onKeydown)
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    onKeydown (e) {
      if (e.key === 'Escape') this.$emit('close')
    }
  }
}
</script>

<style scoped>
.bh-modal {
  position: fixed;
  inset: 0;
  z-index: 99999;
}

.bh-overlay {
  position: absolute;
  inset: 0;
  background: rgba(17, 24, 39, 0.55);
}

.bh-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(920px, calc(100% - 32px));
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 24px 60px rgba(0,0,0,0.25);
  overflow: hidden;
}

.bh-header {
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bh-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.bh-app-icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: #111827;
  color: #2dd4bf;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.bh-title {
  font-weight: 800;
  color: #111827;
  font-size: 16px;
}

.bh-divider {
  height: 1px;
  background: #e5e7eb;
}

.bh-body {
  padding: 14px 18px 18px;
}

.bh-section + .bh-section {
  margin-top: 18px;
}

.bh-section-title {
  font-weight: 800;
  color: #374151;
  margin-bottom: 10px;
  font-size: 14px;
}

.bh-steps {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 16px;
}

.bh-steps li {
  position: relative;
  padding-left: 36px;
  padding-top: 4px;
  color: #4b5563;
  line-height: 1.35;
  font-size: 14px;
}

.bh-steps li::before {
  content: counter(step);
}

.bh-steps {
  counter-reset: step;
}

.bh-steps li::before {
  counter-increment: step;
  content: counter(step);
  position: absolute;
  left: 0;
  top: 1px;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  border: 1px solid #dbe2ff;
  background: #f8fafc;
  color: #1f4db8;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

@media (max-width: 600px) {
  .bh-body {
    padding: 12px 14px 14px;
  }
  .bh-title {
    font-size: 15px;
  }
}
</style>

